import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Upload, FileText, Settings, ScanLine
} from 'lucide-react';
import NotificationBell from './NotificationBell';

const navItems = [
  { to: '/spatial/templates', icon: Settings, label: 'Templates' },
];

const digitizeItems = [
  { to: '/spatial/digitize/upload', icon: ScanLine, label: 'Quick Digitize' },
  { to: '/spatial/digitize/dashboard', icon: FileText, label: 'Digitize Projects' },
];

function NavTab({ to, icon: Icon, label }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <NavLink
      to={to}
      data-testid={`spatial-tab-${label.toLowerCase().replace(/\s/g, '-')}`}
      className={`flex items-center gap-2 px-4 py-2 text-xs font-semibold uppercase tracking-wider transition-colors whitespace-nowrap rounded-sm ${
        isActive
          ? 'bg-teal-100 text-teal-700 border-b-2 border-teal-500'
          : 'text-slate-500 hover:text-slate-900 hover:bg-slate-100'
      }`}
    >
      <Icon className="w-3.5 h-3.5" />
      <span>{label}</span>
    </NavLink>
  );
}

export default function SpatialPageWrapper({ children }) {
  return (
    <div className="min-h-full bg-slate-50 dark:bg-slate-900" data-testid="spatial-wrapper">
      {/* Sub-navigation bar */}
      <div className="sticky top-0 z-20 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1 overflow-x-auto py-2">
            {navItems.map((item) => (
              <NavTab key={item.to} {...item} />
            ))}
            <div className="w-px h-5 bg-slate-300 dark:bg-slate-700 mx-2 shrink-0" />
            <span className="text-[9px] font-semibold uppercase tracking-widest text-slate-400 mr-2 shrink-0">Paper-to-Digital</span>
            {digitizeItems.map((item) => (
              <NavTab key={item.to} {...item} />
            ))}
          </div>
          <div className="shrink-0 ml-4">
            <NotificationBell />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative">
        {children}
      </div>
    </div>
  );
}
